/** 六單據共用狀態 label／filter（DRAFT／SUBMITTED／COMPLETED）。 */

export const DOCUMENT_STATUS_LABELS = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  COMPLETED: '已完成',
};

export const DOCUMENT_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'SUBMITTED', label: '已提交' },
  { value: 'COMPLETED', label: '已完成' },
];

export function formatDocumentStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  return DOCUMENT_STATUS_LABELS[status] ?? '—';
}
